// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"122420b4","361":"dbb83a65","378":"dbb83a65","572":"d7aa1edf"}[chunkId] + ".chunk.css";
};